import type { InjectionKey, Ref } from 'vue';
import { Direction } from '@/components/base-components/types/direction';

export interface BaseStepsContext {
    steps: Ref<Array<unknown>>;
    active: Ref<number>;
    marker: Ref<boolean | undefined>;
    centered: Ref<boolean | undefined>;
    direction: Ref<Direction>;
}

export const BaseSteps: InjectionKey<BaseStepsContext> = Symbol('BaseSteps');
